import type { AppBadgeColor } from '../../app-badge'
import type { BadgePaymentServiceProps } from '../types/interfaces'

import { useListsStore } from '@shared/model'
import { TutorBillingPaymentService } from '@shared/config'

interface BadgePaymentServiceOptions {
  props: BadgePaymentServiceProps
}

interface BadgePaymentServiceReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const COLORS: Record<TutorBillingPaymentService, AppBadgeColor> = {
  [TutorBillingPaymentService.Gcash]: 'emerald',
  [TutorBillingPaymentService.Paypal]: 'blue',
  [TutorBillingPaymentService.Payoneer]: 'orange',
  [TutorBillingPaymentService.Wire]: 'slate',
}

export const useBadgePaymentService = ({ props }: BadgePaymentServiceOptions): BadgePaymentServiceReturn => {
  const listsStore = useListsStore()

  const color = computed<AppBadgeColor>(() => COLORS[props.service as TutorBillingPaymentService] ?? 'slate')
  const text = computed<string>(() => listsStore.getTutorBillingPaymentServiceLabel(props.service))

  return {
    color,
    text,
  }
}
